import { render, staticRenderFns } from "./saveBusinessNews.vue?vue&type=template&id=e9bcf484"
import script from "./saveBusinessNews.vue?vue&type=script&lang=js"
export * from "./saveBusinessNews.vue?vue&type=script&lang=js"
import style0 from "./saveBusinessNews.vue?vue&type=style&index=0&id=e9bcf484&prod&media=screen&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports